// src/utils/indexedDB.js

export const openDB = () => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open('atendeDB_2', 4);
    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains('pendingUpdates')) {
        db.createObjectStore('pendingUpdates', { keyPath: 'id', autoIncrement: true });
      }
      if (!db.objectStoreNames.contains('lastStatus')) {
        db.createObjectStore('lastStatus', { keyPath: 'userId' });
      }
      if (!db.objectStoreNames.contains('params')) {
        db.createObjectStore('params', { keyPath: 'key' });
      }
      // ✅ Cria o object store "status" se não existir
      if (!db.objectStoreNames.contains('status')) {
        const store = db.createObjectStore('status', { keyPath: 'id' });
        // Inicializa com o objeto correto
        store.transaction.oncomplete = () => {
          const transaction = db.transaction('status', 'readwrite');
          const statusStore = transaction.objectStore('status');
          statusStore.add({
            id: 1, // 🔥 Define explicitamente um ID
            available: [],
            inService: [],
            unavailable: [],
          });
        };
      }
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
};

// 📌 Funções para Pending Updates
export const addPendingUpdate = async (update) => {
  const db = await openDB();
  const tx = db.transaction('pendingUpdates', 'readwrite');
  const store = tx.objectStore('pendingUpdates');
  store.add(update);
  return tx.complete;
};

export const getAllPendingUpdates = async () => {
  const db = await openDB();
  const tx = db.transaction('pendingUpdates', 'readonly');
  const store = tx.objectStore('pendingUpdates');
  const request = store.getAll();

  return new Promise((resolve, reject) => {
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
};

export const clearPendingUpdates = async () => {
  const db = await openDB();
  const tx = db.transaction('pendingUpdates', 'readwrite');
  const store = tx.objectStore('pendingUpdates');
  store.clear();
  return tx.complete;
};

// 📌 Funções para Status dos Usuários
export const saveLastStatus = async (userId, status) => {
  const db = await openDB();
  const tx = db.transaction('lastStatus', 'readwrite');
  const store = tx.objectStore('lastStatus');
  store.put({ userId, status, timestamp: new Date().toISOString() });
  return tx.complete;
};

export const getStatus = () => {
  return new Promise(async (resolve, reject) => {
    const db = await openDB();
    const transaction = db.transaction('status', 'readonly');
    const store = transaction.objectStore('status');
    const request = store.get(1); // Pegamos o objeto inicializado com id 1

    request.onsuccess = () => {
      resolve(
        request.result || { available: [], inService: [], unavailable: [] }
      );
    };
    request.onerror = () => reject(request.error);
  });
};

export const saveStatus = async (newStatus) => {
  try {
    const db = await openDB();
    const transaction = db.transaction('status', 'readwrite');
    const store = transaction.objectStore('status');
    // Garante que sempre usamos o mesmo ID (1) para armazenar o status
    await store.put({ id: 1, ...newStatus });
    console.log('Status atualizado no IndexedDB:', newStatus);
  } catch (error) {
    console.error('Erro ao salvar status no IndexedDB:', error);
  }
};

// 📌 Funções para armazenar e recuperar os PARAMS
export const saveParam = async (key, value) => {
  const db = await openDB();
  const tx = db.transaction('params', 'readwrite');
  const store = tx.objectStore('params');
  store.put({ key, value });
  return tx.complete;
};

export const getParam = async (key) => {
  const db = await openDB();
  const tx = db.transaction('params', 'readonly');
  const store = tx.objectStore('params');
  return store.get(key);
};

// 📌 Funções para armazenar e recuperar os USERS
export const saveUser = async (newUser) => {
  const db = await openDB();
  const transaction = db.transaction('users', 'readwrite');
  const store = transaction.objectStore('users');
  
  const usersData = await getUsers();
  usersData.push(newUser); // Adiciona o novo usuário ao array
  
  store.put({ id: 1, users: usersData }); // Sobrescreve o objeto armazenado
};

export const getUsers = () => {
  return new Promise(async (resolve, reject) => {
    const db = await openDB();
    const transaction = db.transaction('users', 'readonly');
    const store = transaction.objectStore('users');
    const request = store.get(1); // Pegamos o objeto inicializado com id 1

    request.onsuccess = () => resolve(request.result ? request.result.users : []);
    request.onerror = () => reject(request.error);
  });
};
